import { PAUSE_BACKGROUND_REQUESTS } from "../actions/types";

export default (val = false, action) => {
  if (action.type === PAUSE_BACKGROUND_REQUESTS) {
    return action.payload;
  }
  return val;
};
